import { DE_CURRENCY_FORMAT } from '@eb/intl';

export const ENV_PROP_FIXTURE = {
    serverUrl: 'serverUrl',
    ebDomain: 'ebDomain',
    adminServerUrl: 'adminServerUrl',
    signupUrl: 'signupUrl',
    loginUrl: 'loginUrl',
    logoutUrl: 'logoutUrl',
    searchLocation: { address: 'searchLocation' },
    currencyFormat: DE_CURRENCY_FORMAT,
    locales: [
        { locale: 'es_AR', locale_name: 'Argentina' },
        { locale: 'en_AU', locale_name: 'Australia' },
        { locale: 'nl_BE', locale_name: 'België' },
        { locale: 'fr_BE', locale_name: 'Belgique' },
        { locale: 'pt_BR', locale_name: 'Brasil' },
        { locale: 'en_CA', locale_name: 'Canada (EN)' },
        { locale: 'fr_CA', locale_name: 'Canada (FR)' },
        { locale: 'es_CL', locale_name: 'Chile' },
        { locale: 'es_CO', locale_name: 'Colombia' },
        { locale: 'de_DE', locale_name: 'Deutschland' },
        { locale: 'es_ES', locale_name: 'España' },
        { locale: 'fr_FR', locale_name: 'France' },
        { locale: 'en_HK', locale_name: 'Hong Kong' },
        { locale: 'en_IE', locale_name: 'Ireland' },
        { locale: 'it_IT', locale_name: 'Italia' },
        { locale: 'es_MX', locale_name: 'Mexico' },
        { locale: 'nl_NL', locale_name: 'Nederland' },
        { locale: 'en_NZ', locale_name: 'New Zealand' },
        { locale: 'de_AT', locale_name: 'Österreich' },
        { locale: 'es_PE', locale_name: 'Peru' },
        { locale: 'pt_PT', locale_name: 'Portugal' },
        { locale: 'en_SG', locale_name: 'Singapore' },
        { locale: 'en_GB', locale_name: 'United Kingdom' },
        { locale: 'en_US', locale_name: 'United States' },
    ],
    localeInfo: {
        tld: '.de',
        locale: 'de_DE',
        locale_name: 'Deutschland',
        contact_us_path: 'localeContactUsPath',
        contact_us_url: 'localeContactUsUrl',
        sales_contact_landing_page: 'localeSalesContactLanding',
        sales_contact_link_text: 'localeSalesContactLinkText',
        twitter_page: 'localeTwitter',
        twitter_handle: 'localeTwitterHandle',
        facebook_page: 'localeFacebookPage',
        facebook_locale: 'localeFacebook',
        linked_in_page: 'localeLinkedIn',
        instagram_page: 'localeInstagram',
        blog_url: 'localeBlog',
    },
    helpUrls: {
        home: 'helpHome',
        impressum: 'helpImpressum',
        suggested: [],
    },
    organizeUrls: {
        home: {
            url: 'organizeUrl',
            label: 'organizeUiLabel',
            gaLabel: 'organizeGaLabel',
        },
        suggested: [],
    },
    isManageOverviewActive: true,
};

export const USER_PROP_FIXTURE = {
    publicId: '226753142328',
    email: 'eng@eventbrite.com',
    fullName: 'Eventbrite Developer',
    firstName: 'Eventbrite',
    lastName: 'Developer',
    isAuthenticated: true,
    hasEvents: true,
    hasOrganizers: true,
    canCreateEvents: true,
    canUseStudio: true,
    isAttendee: false,
    thumbnailUrl: 'https://path.com/to/image',
    numOrders: 6,
    numSavedEvents: 52,
    numFollowing: 22,
    canInvite: true,
    canUseSponsorships: true,
    canUseCredits: true,
    hasTikibar: false,
    isStaff: false,
};

export const FEATURE_FLAGS_FIXTURE = {
    launchCreatorCreditsSectionAttendee: true,
};
